import React, { useState } from "react";
import ProcessBar from "../MainComponent/processBar";
import "./summary.css";
import SummaryInfo from "./summaryInfo";
import { Link } from "react-router-dom";

export default function SummaryDetail() {
  const projectId = sessionStorage.getItem("projectId");
  const [submitLoader, setSubmitLoader] = useState(false);

  return (
    <>
      {submitLoader && (
        <div className="submitLoader" style={{ backgroundColor: `#ffffff3d` }}>
          <div className="ring"></div>
          <img src="./images/Logos/flash.svg" alt="logo"></img>
        </div>
      )}
      <div className="summaryDetail">
        <div className="summaryHead">
          <div className="detailHeader">
            <Link to="/Dashboard">
              <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
            </Link>
            <h6>/</h6>
            {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
          </div>
          <ProcessBar></ProcessBar>
        </div>
        <SummaryInfo
          submitLoader={submitLoader}
          setSubmitLoader={setSubmitLoader}
        ></SummaryInfo>
      </div>
    </>
  );
}
